console.log("meowcart-store-locator.js loaded")

var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  encode: function (input) {
    var output = ""
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4
    var i = 0

    input = Base64._utf8_encode(input)

    while (i < input.length) {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)

      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63

      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }

      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4)
    }
    return output
  },

  decode: function (input) {
    var output = ""
    var chr1, chr2, chr3
    var enc1, enc2, enc3, enc4
    var i = 0

    input = input.replace(/[^A-Za-z0-9+/=]/g, "")

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++))
      enc2 = this._keyStr.indexOf(input.charAt(i++))
      enc3 = this._keyStr.indexOf(input.charAt(i++))
      enc4 = this._keyStr.indexOf(input.charAt(i++))

      chr1 = (enc1 << 2) | (enc2 >> 4)
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2)
      chr3 = ((enc3 & 3) << 6) | enc4

      output = output + String.fromCharCode(chr1)

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2)
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3)
      }
    }

    output = Base64._utf8_decode(output)

    return output
  },

  _utf8_encode: (string) => {
    string = string.replace(/\r\n/g, "\n")
    var utftext = ""

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n)

      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  },

  _utf8_decode: (utftext) => {
    var string = ""
    var i = 0
    var c = 0
    var c1 = 0
    var c2 = 0
    var c3 = 0

    while (i < utftext.length) {
      c = utftext.charCodeAt(i)

      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return string
  },
}

const styleElement = document.createElement("style")
styleElement.textContent = `
  .mc-sl__body {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
  }
  
  .mc-sl__item {
    border: 1px solid #e5e5e5;
    padding: 20px;
    border-radius: 8px;
    transition: all 0.3s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: white;
  }
  
  .mc-sl__item:hover {
    border-color: #000;
  }
  
  .mc-sl__city {
    color: #888;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .mc-sl__name {
    color: #006DA4;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .mc-sl__address, .mc-sl__phone, .mc-sl__opening {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    color: #333;
    font-size: 14px;
  }
  
  .mc-sl__icon {
    color: #006DA4;
    width: 20px;
    flex-shrink: 0;
  }
  
  .mc-sl__icon svg {
    width: 20px;
    height: 20px;
    stroke: #006DA4;
  }
  
  .mc-sl__city span:last-child {
    display: none;
  }
  
  .mc-sl__map-link {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #006DA4;
    text-decoration: none;
    margin-top: 5px;
  }
  
  .mc-sl__map-link svg {
    width: 16px;
    height: 16px;
  }
  
  .mc-sl__filter select, .mc-sl__filter-search input {
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    padding: 8px 12px;
  }
  
  .mc-sl__filter-button button {
    border-radius: 6px;
    background-color: #006DA4;
    color: white;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
  }
  
  .mc-sl__filter-province select:focus {
    border: 1px solid #e5e5e5;
    outline: none;
  }
  
  .click-collect-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 80px;
    height: auto;
  }
  
  .store-status {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: #FF6B6B;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
  }
  
  .coming-soon {
    background-color: white;
    padding: 0;
    height: 40px
  }
  
  .click-collect-filter {
    display: flex;
    align-items: center;
    margin-left: 16px;
  }
  
  .click-collect-filter input {
    margin-right: 4px;
  }
  .store-status.hasClickCollect-true {
    right: 110px;
  }
`
document.head.appendChild(styleElement)

const filterElement = document.querySelector(".mc-sl__filter")
const bodyElement = document.querySelector(".mc-sl__body")
const searchInput = document.getElementById("store-search-input") || undefined
const selectProvider = document.querySelector(".mc-sl__filter-province") || undefined
const store_data = []

function searchContent(value, clickCollectOnly = false) {
  if (value === "reset") {
    if (searchInput !== undefined) searchInput.value = ""
    filterElement.querySelector("select").value = "all"
    const checkbox = document.getElementById("click-collect-checkbox")
    if (checkbox) checkbox.checked = false
    filterElement.querySelector(".mc-sl__filter-button button").click()
    return
  }
  if (value === "hide") {
    bodyElement.querySelectorAll(".mc-sl__item").forEach((current) => {
      current.style.display = "none"
    })
    return
  }
  if (value.length <= 0 && !clickCollectOnly) return

  if (store_data && store_data.length > 0) {
    searchContent("hide")
    for (let i = 0; i < store_data.length; i++) {
      if (clickCollectOnly && store_data[i][5] !== "y") continue

      if (
        value.length <= 0 || 
        store_data[i][0].indexOf(stringToSlug(value)) > -1 ||
        store_data[i][1].indexOf(stringToSlug(value)) > -1 ||
        store_data[i][2].indexOf(stringToSlug(value)) > -1 ||
        store_data[i][4].indexOf(stringToSlug(value)) > -1
      ) {
        const element = document.querySelector(
          `[data-handle="${Base64.encode(
            stringToSlug(store_data[i][0]) +
              stringToSlug(store_data[i][1]) +
              stringToSlug(store_data[i][2]) +
              stringToSlug(store_data[i][4]),
          )}"]`,
        )
        if (element) element.style.display = "block"
      }
    }
  }
}


function setEventForHTML(checkbox) {
  if (checkbox) {
    checkbox.addEventListener("change", function () {
      const searchValue = searchInput ? searchInput.value : ""
      searchContent(searchValue)
    })
  }

  filterElement.querySelector(".mc-sl__filter-button button").addEventListener("click", () => {
    const currentHandle = filterElement.querySelector("select")
    if (currentHandle.value === "" && currentHandle.value !== "hide") {
      console.log(currentHandle.value)
      alert("Vui lòng chọn địa điểm trước")
      return
    }

    const clickCollectOnly = document.getElementById("click-collect-checkbox")?.checked || false

    bodyElement.querySelectorAll(".mc-sl__item").forEach((current) => {
      if (currentHandle.value === "hide") {
        current.style.display = "none"
        return
      }

      if (clickCollectOnly && current.getAttribute("data-click-collect") !== "y") {
        current.style.display = "none"
        return
      }

      if (currentHandle.value === "all") {
        current.style.display = "block"
        return
      }

      if (current.getAttribute("data-province") !== stringToSlug(currentHandle.value)) {
        current.style.display = "none"
      } else {
        current.style.display = "block"
      }
    })
  })
}

function stringToSlug(str) {
  // remove accents
  var from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
    to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy"
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(RegExp(from[i], "gi"), to[i])
  }

  str = str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-]/g, "-")
    .replace(/-+/g, "-")

  return str
}

// Declare $ if it's not already in scope
var $ = $ || {}

$.ajax({
  url: "https://script.google.com/macros/s/AKfycbww321OIjwBvuv08vr9eBxOp2DcWAumQR4AnYhTCvHiNUVlx2XKU8MW5SWIGhxaUqF4lw/exec",
  method: "GET",
  dataType: "JSON",
  data: {
    store: "crocs",
  },
  success: (res) => {
    console.log("res", res)
    if (res.code === 200) {
      console.log(res)
      let listCity = []
      bodyElement.innerHTML = ""

      const storeNumElement = document.getElementById("store_num")
      if (storeNumElement) {
        storeNumElement.innerHTML = res.data.length
      }

      for (let i = 0; i < res.data.length; i++) {
        store_data.push([
          stringToSlug(res.data[i][0]),
          stringToSlug(res.data[i][1]),
          stringToSlug(res.data[i][2]),
          stringToSlug(res.data[i][3]),
          stringToSlug(res.data[i][4]),
          stringToSlug(res.data[i][6] || "n"), 
          stringToSlug(res.data[i][7] || ""), 
        ])

        listCity.push(res.data[i][0])

       

        const hasClickCollect = (res.data[i][6] || "").toLowerCase() === "y"
         console.log(res.data[i][5] + 'sgvdgs');

        const storeStatus = (res.data[i][7] || "").toLowerCase()
        let statusHTML = ""
        if (storeStatus === "renovation") {
          statusHTML = `<div class="store-status hasClickCollect-${hasClickCollect} custom-store-status renovation">
            Đang nâng cấp
          </div>`
        } else if (storeStatus === "coming soon") {
          statusHTML = `<div class="store-status coming-soon hasClickCollect-${hasClickCollect}">
            <svg width="75" height="40" viewBox="0 0 75 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect width="75" height="40" fill="url(#pattern0_1224_18531)"/>
            <defs>
            <pattern id="pattern0_1224_18531" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_1224_18531" transform="matrix(0.00277778 0 0 0.00520833 -0.00416667 0)"/>
            </pattern>
            <image id="image0_1224_18531" width="363" height="192" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
            </defs>
            </svg>
            </div>`
        }

        const clickCollectHTML = hasClickCollect
          ? '<img src="https://cdn.shopify.com/s/files/1/0585/8181/1355/files/Vector_Smart_Object43-01.png?v=1744291917" class="click-collect-badge" alt="Click & Collect" />'
          : ""

        bodyElement.innerHTML += `
                <div class="mc-sl__item"
                    data-province="${stringToSlug(res.data[i][0])}"
                    data-number="${stringToSlug(res.data[i][2])}"
                    data-address="${stringToSlug(res.data[i][4])}"
                    data-name="${stringToSlug(res.data[i][1])}"
                    data-click-collect="${(res.data[i][6] || "n").toLowerCase()}"
                    data-status="${stringToSlug(res.data[i][7] || "")}"
                    data-handle="${Base64.encode(
                      stringToSlug(res.data[i][0]) +
                        stringToSlug(res.data[i][1]) +
                        stringToSlug(res.data[i][2]) +
                        stringToSlug(res.data[i][4]),
                    )}"
                >
                    <div>
                    <div class="mc-sl__city">
                        ${res.data[i][0]}
                    </div>
                    <div class="mc-sl__name">${res.data[i][1]}</div>
                    <div>
                      <div class="mc-sl__address">
                        <span class="mc-sl__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.5 8.33337C17.5 14.1667 10 19.1667 10 19.1667C10 19.1667 2.5 14.1667 2.5 8.33337C2.5 6.34425 3.29018 4.4366 4.6967 3.03007C6.10322 1.62355 8.01088 0.833374 10 0.833374C11.9891 0.833374 13.8968 1.62355 15.3033 3.03007C16.7098 4.4366 17.5 6.34425 17.5 8.33337Z" stroke="#1C1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M10 10.8334C11.3807 10.8334 12.5 9.71408 12.5 8.33337C12.5 6.95266 11.3807 5.83337 10 5.83337C8.61929 5.83337 7.5 6.95266 7.5 8.33337C7.5 9.71408 8.61929 10.8334 10 10.8334Z" stroke="#1C1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span>${res.data[i][4]}</span>
                    </div>
                    <div class="mc-sl__phone">
                        <span class="mc-sl__icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18.3333 14.1V16.6C18.3343 16.8321 18.2867 17.0618 18.1937 17.2744C18.1008 17.4871 17.9644 17.678 17.7934 17.8349C17.6224 17.9918 17.4205 18.1112 17.2006 18.1856C16.9808 18.2599 16.7478 18.2875 16.5167 18.2666C13.9523 17.988 11.4892 17.1118 9.32498 15.7083C7.31151 14.4289 5.60443 12.7218 4.32499 10.7083C2.91663 8.53432 2.04019 6.05914 1.76665 3.48331C1.74583 3.25287 1.77321 3.02061 1.84707 2.80133C1.92092 2.58205 2.03963 2.38055 2.19562 2.20966C2.35162 2.03877 2.54149 1.90224 2.75314 1.80875C2.9648 1.71526 3.1936 1.66686 3.42499 1.66665H5.92499C6.32941 1.66267 6.72148 1.80588 7.02812 2.06959C7.33476 2.3333 7.53505 2.69952 7.59165 3.09998C7.69717 3.90003 7.89286 4.68558 8.17499 5.44165C8.2871 5.73992 8.31137 6.06407 8.24491 6.37571C8.17844 6.68735 8.02404 6.9734 7.79998 7.19998L6.74165 8.25831C7.92795 10.3446 9.65536 12.072 11.7417 13.2583L12.8 12.2C13.0266 11.9759 13.3126 11.8215 13.6243 11.7551C13.9359 11.6886 14.26 11.7129 14.5583 11.825C15.3144 12.1071 16.0999 12.3028 16.9 12.4083C17.3048 12.4654 17.6745 12.6693 17.9388 12.9812C18.203 13.2931 18.3435 13.6913 18.3333 14.1Z" stroke="#1C1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span>${res.data[i][2]}</span>
                    </div>
                    <div class="mc-sl__opening custom-mc-sl__opening">
                        <span class="mc-sl__icon">
                           <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1201_18772)">
                            <path d="M10 5.00002V10L13.3334 11.6667M18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C14.6024 1.66669 18.3334 5.39765 18.3334 10Z" stroke="#1C1D1D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_1201_18772">
                            <rect width="20" height="20" fill="white"/>
                            </clipPath>
                            </defs>
                          </svg>
                        </span>
                        <span>Giờ hoạt động: ${res.data[i][3]}</span>
                    </div>
                    </div>
                    </div>
                    <div class="mc-sl__map-status">
                       <div class="mc-sl__map">
                      <span class="mc-sl__icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.8334 5.00002C15.8334 5.46026 15.4603 5.83335 15 5.83335C14.5398 5.83335 14.1667 5.46026 14.1667 5.00002C14.1667 4.53978 14.5398 4.16669 15 4.16669C15.4603 4.16669 15.8334 4.53978 15.8334 5.00002Z" fill="#1D1D1D"/>
                          <path d="M13.0556 10.75C13.4698 10.75 13.8056 10.4142 13.8056 10C13.8056 9.58579 13.4698 9.25 13.0556 9.25V10.75ZM5.83333 15.0833C5.41912 15.0833 5.08333 15.4191 5.08333 15.8333C5.08333 16.2475 5.41912 16.5833 5.83333 16.5833V15.0833ZM14.1852 8.06981L13.6723 8.61701L14.1852 8.06981ZM15.8148 8.06982L15.3019 7.5226L15.8148 8.06982ZM13.285 5.40657C13.0627 4.18225 13.9391 3.25 15 3.25V1.75C13.0127 1.75 11.418 3.52045 11.8091 5.67451L13.285 5.40657ZM15 3.25C16.0608 3.25 16.9372 4.18223 16.715 5.40661L18.1909 5.67447C18.5819 3.52048 16.9873 1.75 15 1.75V3.25ZM14.6981 7.5226C14.0672 6.93122 13.4184 6.1412 13.285 5.40657L11.8091 5.67451C12.0363 6.92579 13.0193 8.00493 13.6723 8.61701L14.6981 7.5226ZM16.715 5.40661C16.5817 6.14121 15.9329 6.93122 15.3019 7.5226L16.3277 8.61704C16.9807 8.00496 17.9638 6.92579 18.1909 5.67447L16.715 5.40661ZM7.29167 10.75H13.0556V9.25H7.29167V10.75ZM7.29167 13.6667H15.2083V12.1667H7.29167V13.6667ZM15.2083 15.0833H5.83333V16.5833H15.2083V15.0833ZM4.16667 16.75C3.66041 16.75 3.25 16.3396 3.25 15.8333H1.75C1.75 17.168 2.83198 18.25 4.16667 18.25V16.75ZM5.08333 15.8333C5.08333 16.3396 4.67293 16.75 4.16667 16.75V18.25C5.50135 18.25 6.58333 17.168 6.58333 15.8333H5.08333ZM4.16667 14.9167C4.67293 14.9167 5.08333 15.3271 5.08333 15.8333H6.58333C6.58333 14.4986 5.50135 13.4167 4.16667 13.4167V14.9167ZM4.16667 13.4167C2.83198 13.4167 1.75 14.4986 1.75 15.8333H3.25C3.25 15.3271 3.66041 14.9167 4.16667 14.9167V13.4167ZM15.2083 13.6667C15.5995 13.6667 15.9167 13.9838 15.9167 14.375H17.4167C17.4167 13.1554 16.428 12.1667 15.2083 12.1667V13.6667ZM5.08333 11.4583C5.08333 12.678 6.07204 13.6667 7.29167 13.6667V12.1667C6.90047 12.1667 6.58333 11.8495 6.58333 11.4583H5.08333ZM7.29167 9.25C6.07204 9.25 5.08333 10.2387 5.08333 11.4583H6.58333C6.58333 11.0671 6.90047 10.75 7.29167 10.75V9.25ZM15.9167 14.375C15.9167 14.7662 15.5995 15.0833 15.2083 15.0833V16.5833C16.428 16.5833 17.4167 15.5946 17.4167 14.375H15.9167ZM13.6723 8.61701C14.4253 9.32271 15.5748 9.32273 16.3277 8.61704L15.3019 7.5226C15.1259 7.68753 14.8741 7.68753 14.6981 7.5226L13.6723 8.61701Z" fill="#1D1D1D"/>
                        </svg>
                      </span>
                      <a href="${res.data[i][5]}" target="_blank" class="mc-sl__map-link">
                        Xem Chỉ Đường
                      </a>
                    </div>
                    ${statusHTML}
                    </div>
                    ${clickCollectHTML}
                </div>
            `
      }

      listCity = listCity.reduce((uniq, item) => (uniq.includes(item) ? uniq : [...uniq, item]), [])

      const selectElement = filterElement.querySelector("select")
      if (selectElement) {
        selectElement.innerHTML += `
                    <option value="all">Xem tất cả</option>
                `
        for (let i = 0; i < listCity.length; i++) {
          selectElement.innerHTML += `
                        <option value="${listCity[i].trim()}">${listCity[i]}</option>
                    `
        }
      }

      if (searchInput) {
        searchInput.addEventListener("focusin", () => {
          const searchContainer = document.querySelector(".mc-sl__filter-search")
          // if (searchContainer) searchContainer.style.maxWidth = "100%"
          // if (selectProvider) selectProvider.style.display = "none"
          const button = filterElement.querySelector(".mc-sl__filter-button button")
          // if (button) button.style.display = "none"
        })

        searchInput.addEventListener("focusout", () => {
          const searchContainer = document.querySelector(".mc-sl__filter-search")
          // if (searchContainer) searchContainer.style.maxWidth = "fit-content"
          if (selectProvider) selectProvider.style.display = "block"
          const button = filterElement.querySelector(".mc-sl__filter-button button")
          if (button) button.style.display = "block"
        })

        searchInput.addEventListener("keyup", function () {
          const search_value = this.value
          if (search_value.length > 0) {
            searchContent(search_value)
          } else {
            searchContent("reset")
          }
        })
      }
      const clickCollectFilter = document.createElement("div")
      clickCollectFilter.className = "click-collect-filter"
      clickCollectFilter.innerHTML = `
            <input type="checkbox" id="click-collect-checkbox">
            <label for="click-collect-checkbox">Click&Collect</label>
        `
      const clickCollectElement = document.getElementById("mc-sl__clickandcollect")
      clickCollectElement.appendChild(clickCollectFilter)
      // filterElement.appendChild(clickCollectFilter)
      const currentHandle = filterElement.querySelector("select")
      
      const checkbox = document.getElementById("click-collect-checkbox")
      if (checkbox) {
        checkbox.addEventListener("change", function () {
          if (checkbox.checked) {
            bodyElement.querySelectorAll(".mc-sl__item").forEach((current) => {
              if (current.getAttribute("data-click-collect") !== "y") {
                current.style.display = "none"
              }
              if (stringToSlug(currentHandle.value) == "" | stringToSlug(currentHandle.value) == "all"  && current.getAttribute("data-click-collect") !== "y") {
                current.style.display = "none"
              }
            })
          }
          else {
            bodyElement.querySelectorAll(".mc-sl__item").forEach((current) => {
              if (stringToSlug(currentHandle.value) !== "" && stringToSlug(currentHandle.value) == current.getAttribute("data-province") && current.getAttribute("data-click-collect") !== "y") {
                current.style.display = "block"
              }
              if (stringToSlug(currentHandle.value) == "" | stringToSlug(currentHandle.value) == "all"  && current.getAttribute("data-click-collect") !== "y") {
                current.style.display = "block"
              }
            })
          }
        })
      } 
      setEventForHTML(checkbox)
    }
  },
  error: (err) => {
    console.error("Error fetching store data:", err)
  },
})
console.log("meowcart-store-locator.js ended")
